import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {CoreService} from "../shared/services/core.service";
@Injectable({
  providedIn: 'root'
})
export class ManualRoutingGuard implements CanActivate {
  constructor(private coreService: CoreService) {
  }
  canActivate(
    _route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return !this.coreService.blockRoutes;
  }
}
